export const statDynaProperties = [
	{
	type: "Dual Contained Pipeline",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"From",
	"Inner Diameter (inches)",
	"Inner Diameter (mm)",
	"Line Number",
	"Linear Pipe Weight (kg/m)",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"Outer Diameter (inches)",
	"Outer Diameter (mm)",
	"P&ID Class",
	"PID Drawing No.",
	"Pipe Pressure Rating (barg)",
	"Pipe Schedule / SDR",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"To",
	"Wall Thickness (inches)",
	"Wall Thickness (mm)",
	],
	dynamic: [
	"Note",
	"Average Flow Rate (l/s)",
	"Average Flow Speed (m/s)",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Heat Tracing",
	"Installed By",
	"Insulation Thickness (mm)",
	"Insulation Type",
	"Lagging",
	"Maximum Flow Rate (l/s)",
	"Maximum Flow Speed (m/s)",
	"Minimum Flow Rate (l/s)",
	"Minimum Flow Speed (m/s)",
	"Planned Test Pressure (barg)",
	"Plant Group",
	"Plant System",
	"Pressure Test Required",
	"Process Group",
	"Purchased By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Carried Out by",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Future Pipeline",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"From",
	"Inner Diameter (inches)",
	"Inner Diameter (mm)",
	"Line Number",
	"Linear Pipe Weight (kg/m)",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"Outer Diameter (inches)",
	"Outer Diameter (mm)",
	"P&ID Class",
	"PID Drawing No.",
	"Pipe Pressure Rating (barg)",
	"Pipe Schedule / SDR",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"To",
	"Wall Thickness (inches)",
	"Wall Thickness (mm)",
	],
	dynamic: [
	"Note",
	"Average Flow Rate (l/s)",
	"Average Flow Speed (m/s)",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Heat Tracing",
	"Installed By",
	"Insulation Thickness (mm)",
	"Insulation Type",
	"Lagging",
	"Maximum Flow Rate (l/s)",
	"Maximum Flow Speed (m/s)",
	"Minimum Flow Rate (l/s)",
	"Minimum Flow Speed (m/s)",
	"Planned Test Pressure (barg)",
	"Plant Group",
	"Plant System",
	"Pressure Test Required",
	"Process Group",
	"Purchased By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Carried Out by",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Major Pipeline",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"From",
	"Inner Diameter (inches)",
	"Inner Diameter (mm)",
	"Line Number",
	"Linear Pipe Weight (kg/m)",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"Outer Diameter (inches)",
	"Outer Diameter (mm)",
	"P&ID Class",
	"PID Drawing No.",
	"Pipe Pressure Rating (barg)",
	"Pipe Schedule / SDR",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"To",
	"Wall Thickness (inches)",
	"Wall Thickness (mm)",
	],
	dynamic: [
	"Note",
	"Average Flow Rate (l/s)",
	"Average Flow Speed (m/s)",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Heat Tracing",
	"Installed By",
	"Insulation Thickness (mm)",
	"Insulation Type",
	"Lagging",
	"Maximum Flow Rate (l/s)",
	"Maximum Flow Speed (m/s)",
	"Minimum Flow Rate (l/s)",
	"Minimum Flow Speed (m/s)",
	"Planned Test Pressure (barg)",
	"Plant Group",
	"Plant System",
	"Pressure Test Required",
	"Process Group",
	"Purchased By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Carried Out by",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Major Pipeline - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"From",
	"Line Number",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Pressure (barg)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"To",
	],
	dynamic: [
	"Note",
	"Average Flow Rate (l/s)",
	"Average Flow Speed (m/s)",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Heat Tracing",
	"Installed By",
	"Insulation Thickness (mm)",
	"Insulation Type",
	"Lagging",
	"Maximum Flow Rate (l/s)",
	"Maximum Flow Speed (m/s)",
	"Minimum Flow Rate (l/s)",
	"Minimum Flow Speed (m/s)",
	"Planned Test Pressure (barg)",
	"Plant Group",
	"Plant System",
	"Pressure Test Required",
	"Process Group",
	"Purchased By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Carried Out by",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Minor Pipeline",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"From",
	"Inner Diameter (inches)",
	"Inner Diameter (mm)",
	"Line Number",
	"Linear Pipe Weight (kg/m)",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"Outer Diameter (inches)",
	"Outer Diameter (mm)",
	"P&ID Class",
	"PID Drawing No.",
	"Pipe Pressure Rating (barg)",
	"Pipe Schedule / SDR",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"To",
	"Wall Thickness (inches)",
	"Wall Thickness (mm)",
	],
	dynamic: [
	"Note",
	"Average Flow Rate (l/s)",
	"Average Flow Speed (m/s)",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Heat Tracing",
	"Installed By",
	"Insulation Thickness (mm)",
	"Insulation Type",
	"Lagging",
	"Maximum Flow Rate (l/s)",
	"Maximum Flow Speed (m/s)",
	"Minimum Flow Rate (l/s)",
	"Minimum Flow Speed (m/s)",
	"Planned Test Pressure (barg)",
	"Plant Group",
	"Plant System",
	"Pressure Test Required",
	"Process Group",
	"Purchased By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Carried Out by",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Minor Pipeline - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"From",
	"Line Number",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Pressure (barg)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"To",
	],
	dynamic: [
	"Note",
	"Average Flow Rate (l/s)",
	"Average Flow Speed (m/s)",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Heat Tracing",
	"Installed By",
	"Insulation Thickness (mm)",
	"Insulation Type",
	"Lagging",
	"Maximum Flow Rate (l/s)",
	"Maximum Flow Speed (m/s)",
	"Minimum Flow Rate (l/s)",
	"Minimum Flow Speed (m/s)",
	"Planned Test Pressure (barg)",
	"Plant Group",
	"Plant System",
	"Pressure Test Required",
	"Process Group",
	"Purchased By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Carried Out by",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Capillary Signal",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Capillary Signal - Existing",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Electric Signal",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Electric Signal - Existing",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Equipment Leader",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "General Signal",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "General Signal - Existing",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Hydraulic Signal",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Hydraulic Signal - Existing",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Leader",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Motor Leader",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Pneumatic Signal",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Pneumatic Signal - Existing",
	static: [
	"3D Model Class",
	"From",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"To",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Axial Blower Fan",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Centrifugal Blower",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "General Blower",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Basic Belt Conveyor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Basic Belt Conveyor With Chevrons",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bucket Elevator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Scraper Conveyor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Scraper Conveyor With Incline",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Screw Conveyor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Screw Conveyor With Incline",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Screw Conveyor Reversing",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Screw Feeder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Vibrator Feeder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Weigh Feeder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bicarbone Filter",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Chlorine Bottle",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Filtromatic Filter",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Horizontal Pressure Filter",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Lamella Separator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Oil Separator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rapid Gravity Filter",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "RO Stack",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Vacuum Filter",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Trickling Filter - Plastic Structured Media",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Trickling Filter (Rock Media)",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Vertical Pressure Filter",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Cup Screen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Curved Bar Screen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Curved Bar Screen With Rotating Arm",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Drum Screen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Hand Raked Screen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Brushed Screen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Vertical Bar Screen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "After Cooler",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Air Blown Cooler",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Basic Element Heater",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Basic Heat Exchanger",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Concentric Tube Exchanger",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Forced Draft Cooling Tower",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Plate Type Exchanger",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Refrigerator Drier",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Shell And Tube Exchanger",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Shell And Tube Exchanger (Removable Tubes)",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Air Motor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Electric Motor - Fixed Speed",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Electric Motor - Variable Speed",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Gearbox",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Integrated Fan",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Reciprocating Engine",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Aerator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "High Speed Aerator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Horizontal Rotor Aerator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Surface Aerator Type SA",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Surface Aerator Type SA Floating",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Surface Aerator Type TMA",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Gas Burner",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Oil Burner",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Emergency Shower With Header Tank",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Emergency Eye Bath",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Emergency Shower",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Hose Reel",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "CV Grit Channel Travelling Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Grit Classifier - Reciprocating Rake",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Grit Classifier - Screw",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Grit Classifier - Vortex",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Packaged Equipment",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Road Tanker",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Universal Sample Module",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flexible Hose",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flexible Ductwork",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Belt Press",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Centrifuge",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Compactor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Filter Press",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Gravity Belt Thickener",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Hydropress",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Washing Compactor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Dechlorination Tablet Feeder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Fan",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "High Speed Stirring Device",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Impeller Mixer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Inline Static Mixer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Low Speed Stirring Device",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Paddle Type Floctuator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Paddle Mixer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Static Tube Aerator/Mixer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Archimedean Screw Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Archimedean Screw Tank Reciruclation Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Axial Blow Fan",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Carboy Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Centrifugal Axial Flow Compressor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Metering Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Positive Displacement - Progressive Cavity Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Positive Displacement - Screw Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Progressive Cavity Macerator Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Reciporcating Pump",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - Centrifugal",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - General",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - Grinder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - Lobe",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - Positive Displacement",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - Submersible",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Pump - Submersible Grinder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Two Stage Reciprocating Compressor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Air Reveiver / Drum",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Closed Tank With Sealed Manway",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Closed Tank With Vent",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Covered Tank",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Degassing Tower",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Dessicant Drier",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Detritor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Digestor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Dorr Type Detritor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Floating Draw Off Arm",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Gas Holder",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Lamella Hopper",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Open Tank",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Saturator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Settlement Tank Conical Bottom",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Settlement Tank Flat Bottom",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Skip / Bin",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Length (m)",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Storage Hopper / Silo",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Storage Hopper / Silo With Vibrator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Storage Tank",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Central Drive Full Bridge",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Peripheral Drive 1/2 Bridge",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flat Bottom Sludge Blanket Clarifier",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Hopper Bottom Sludge Blanket Clarifier",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "SR Type Clarifier",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "XDS Type Clarifier",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Aeration - Coarse Bubble Diffused Air",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Aeration - Fine Bubble Diffused Air",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Aeration - Horizontal Surface",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Aeration - Jet",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Aeration - Vertical Surface",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Dissolved Air Floation",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Nozzle Diffuser Plant",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Central Drive Picket Fence Thickener",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Central Drive WRC Thickener",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Equipment Description",
	"Hazardous Area Specification",
	"Manufacturer",
	"Model",
	"Purchased By",
	"Serial Number",
	"Weight (kg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Angle Pressure Relief",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Angle Vacuum Relief",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Angle Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "3-Way Plug Valve - L Port",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "3-Way Plug Valve - T Port",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "3-Way Valve - L Port",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "3-Way Valve - T Port",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Air Release Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Ball Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Butterfly Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Combination Air Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Condensanate Release Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Diaphragm Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Double Non-Return Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flap Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow Restrictor - Fixed",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow Restrictor - Variable",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Gate Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "General Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Globe Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Hydrant Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Needle Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Non-Return Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Parrallel Slide Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pinch Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Plug Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Ported Sleeve Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pressure Loading Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pressure Reducing Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Feeder Valve",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Ball Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Butterfly Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Gate Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "General Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Globe Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Non-Return Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Parallel Slide Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Plug Valve - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Penstock - Existing",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Penstock",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Stoplog",
	static: [
	"3D Model Class",
	"Above Ground / Below Ground",
	"Class Name",
	"Fluid Code",
	"Long Description (size)",
	"Maximum Fluid Operating Pressure (barg)",
	"Maximum Fluid Operating Temperature (°C)",
	"Mechanical Connection",
	"Minimum Fluid Operating Pressure (barg)",
	"Minimum Fluid Operating Temperature (°C)",
	"P&ID Class",
	"PID Drawing No.",
	"Size (inches)",
	"Size (mm)",
	"Size (NB or OD) (mm or inches)",
	"Size: NB or OD",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Valve Pressure Rating (barg)",
	"Valve Type",
	"Valve CCMS Catalogue Number",
	"Valve Actuator",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Note",
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Purchased By",
	"Valve Orientation",
	"Extension Spindle Size (mm)",
	"Serial Number",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Anti Syphon Device",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bauer Connection",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bell Mouth",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bellows",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bubble Trap",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Bursting Disc",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Calibration Pot",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Closed End Flanged",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Closed End Quick Release",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Closed End Screwed",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Closed End Welded",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Discharge To Atmosphere",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Drain Tundish",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Duplex Filter / Strainer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Ejector / Injector",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Expansion Loop",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Extension Sleeve",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Filter / Strainer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flame Arrestor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flexible Hose",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flume",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Grill / Diffuser",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Hose Coupling",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Inline Coupling",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Inline Flanges",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Inline Spacer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Inline Spade",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Intake From Atmosphere",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Lagging ( Heat Traced)",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Lagging (Thermal)",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Manually Adjustable Bell Mouth",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Motorised Adjustable Bell Mouth",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Orifice Plate",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Outfall",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pipe Interuptor",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pulsation Damper",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rodding Point",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Silencer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Spectacle Blind Closed",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Spectacle Blind Open",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "UHF Antenna",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Warning Light",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Warning Siren",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Weir",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Size (NB or OD) (mm or inches)",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Length (m)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Concentric Reducer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Large Size (mm)",
	"Small Size (mm)",
	"Upstream Size (mm)",
	"Downstream Size (mm)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Eccentric Reducer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Large Size (mm)",
	"Small Size (mm)",
	"Upstream Size (mm)",
	"Downstream Size (mm)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Reducer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Spec",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Large Size (mm)",
	"Small Size (mm)",
	"Upstream Size (mm)",
	"Downstream Size (mm)",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Control Panel - (Field)",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Control Panel - (Local)",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Control Panel - (Main)",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Instrument - Existing",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Instrument - Field Mounted",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Instrument - Local Panel Mounted",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Instrument - Main Panel Mounted",
	static: [
	"3D Model Class",
	"Class Name",
	"P&ID Class",
	"PID Drawing No.",
	"PnID Drawing Number",
	"Status",
	"Tag",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Flow - Electromagnetic",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Flow Nozzle",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - General",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Orifice Plate",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow  - Pitot Tube",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Rotary Displacement",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Sight Glass",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Turbine / Rotary",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Variable Area",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Flow - Venturi Tube",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Existing Instrument",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"Instrument Type",
	"Instrument Description",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"Electrical Installaation By",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "General Instrument",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"Instrument Type",
	"Instrument Description",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"Electrical Installaation By",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "General Instrument Mechanical Indicator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"Instrument Type",
	"Instrument Description",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"Electrical Installaation By",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Displacer",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Electrode Capacitive",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Electrode Conductive",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Float",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - General",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Membrane Diaphragm",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Resistance Strain Guage",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Sight Glass Tank Level",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Level - Ultrasonic",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pressure - Differential",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pressure - General",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Pressure - Mechanical Indicator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Size (mm)",
	"Pipeline Size (inches)",
	"Pipeline Size: NB or OD",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	"Pipeline Spec",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Acidity",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Ammonia",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Conductivity",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Dissolved Oxygen",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Free Chlorine",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Qulaity - General",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Iron",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Nitrates",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Phosphates",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Suspended Solids",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Total Chlorine",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Turbidity",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Ultra Violet Tranmissivity",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Flouride",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Quality - Aluminium",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Temperature - General",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Temperature - Mechanical Indicator",
	static: [
	"3D Model Class",
	"Class Name",
	"Fluid Code",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Pipeline Group Tag",
	"Instrument Type",
	"Instrument Description",
	"Instrument Range",
	"Process Range - Minimum",
	"Process Range - Maximum",
	"Engineering Units",
	"Connection Size (mm or Inches)",
	"Fluid Description",
	"Manufacturer",
	"Transmitter Model",
	"Sensor Model",
	"Cable Part No.",
	"Mounting Model",
	"Supply Voltage Value",
	"No. of Digital Outputs",
	"No. of Analogue Outputs",
	"Comms Method",
	"No. of Solid State Outputs",
	"Supply Voltage Units",
	],
	dynamic: [
	"Delivered To",
	"Description",
	"Hazardous Area Specification",
	"Installed By",
	"Purchased By",
	"Revision",
	"MCC Ref",
	"PLC / IO Node Ref",
	"Electrical Installaation By",
	"Electrical Installation By",
	"Type of Pressure Test",
	"Written Scheme of Examination Required",
	"Test Duration (minutes)",
	"Date of Pressure Test",
	"Actual Test Pressure (barg)",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Closes On Failure",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Element",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Opens On Failure",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Quick Closing",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Quick Opening",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Retain Position On Failure",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Retain Position On Failure Safe Drift Close",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Automatic Actuation Retain Position On Failure Safe Drift Open",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Dash Pot Checked",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Diaphragm",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Diaphragm - Pressure Balance",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Diaphragm - Pressure Regulator With Internal Tap",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Float",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Manual Isolation",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Piston",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Motor",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Solenoid",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Spring",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Statically Loaded",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Weight Loaded",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "Rotary Motor",
	static: [
	"3D Model Class",
	"P&ID Class",
	"PID Drawing No.",
	"Status",
	"Tag",
	"Type",
	],
	dynamic: [
	"Delivered To",
	"Purchased By",
	"Installed By",
	],
	ccms: [
	],
	},
	{
	type: "DWF - General",
	static: [
	"Inner Diameter or Width",
	"Network name",
	"Outer Diameter or Width",
	"Part Size Name",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Geometry",
	static: [
	"3D Length - To Inside Edges",
	"Drop Across Span",
	"End Centerline Elevation",
	"End Cover",
	"End Crown Elevation",
	"End Invert Elevation",
	"End Pipe Name",
	"End Point",
	"End Structure",
	"Maximum Cover",
	"Minimum Cover",
	"Pipe End Easting",
	"Pipe End Northing",
	"Pipe Length 3D",
	"Pipe Start Easting",
	"Pipe Start Northing",
	"Slope",
	"Start Centerline Elevation",
	"Start Cover",
	"Start Crown Elevation",
	"Start Invert Elevation",
	"Start Point",
	"Start Structure",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Hydraulic Properties",
	static: [
	"Flow Rate",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Information",
	static: [
	"Description",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Part Data",
	static: [
	"Material",
	"Wall Thickness",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - General",
	static: [
	"Network name",
	"Part Size Name",
	"Surface Elevation At Insertion Point",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Geometry",
	static: [
	"Structure Easting",
	"Structure Northing",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Information",
	static: [
	"Description",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Insertion Rim Behavior",
	static: [
	"Insertion Rim Elevation",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Part Data",
	static: [
	"Wall Thickness",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Sump Behavior",
	static: [
	"Sump Depth",
	"Sump Elevation",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Item",
	static: [
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - General",
	static: [
	"2D surface area",
	"3D surface area ",
	"Maximum grade/slope",
	"Mean grade/slope",
	"Minimum grade/slope",
	"Surface Maximum Coordinate",
	"Surface Minimum Coordinate",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "DWF - Information",
	static: [
	"Description",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Civil3D",
	static: [
	"Coordinate:Easting",
	"Coordinate:Northing",
	"Coordinate:Point Elevation",
	"Information:Full Description",
	"Information:Point Number",
	"Information:Raw Description",
	],
	dynamic: [
	],
	ccms: [
	],
	},
	{
	type: "Aggregate",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Aggregate Size",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	"Textile",
	],
	ccms: [
	],
	},
	{
	type: "Sand layer",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Aggregate Size",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	"Textile",
	],
	ccms: [
	],
	},
	{
	type: "Blinding",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Wall",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	"Width",
	"Length",
	"Unconnected Height",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Drainage",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Piling",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Plinth",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Slab",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Thrust block",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Wall",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	"Width",
	"Length",
	"Unconnected Height",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Concrete pipe plinth",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Thickness",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Designed Concrete Mix",
	"Cement & Combination Type",
	"Exposure Classes",
	"Designated Concrete Mix",
	"Default Slump Class",
	"Maximum water/cement ratio",
	"Minimum cement/combination content (kg/m3) For 20mm maximum aggregate size",
	"Aggregate Size",
	"Air-entrainment required",
	"Chloride content class",
	"Compressive Strength Class",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Finish",
	"Rebar Laps",
	"Reinforcement",
	"Nominal Cover",
	"Surface Slope",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Subbase",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	],
	ccms: [
	],
	},
	{
	type: "Precast Concrete",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Kerb",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Precast Manhole Cover",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Precast Manhole Ring",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Textile",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"DPM",
	"Reference Product",
	"Textile",
	],
	ccms: [
	],
	},
	{
	type: "Mortar",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	"Sealing details",
	],
	ccms: [
	],
	},
	{
	type: "Grout",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	"Sealing details",
	],
	ccms: [
	],
	},
	{
	type: "Resin",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	"Sealing details",
	],
	ccms: [
	],
	},
	{
	type: "Grout resin",
	static: [
	"Description",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	"Sealing details",
	],
	ccms: [
	],
	},
	{
	type: "Cover",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Stacker box section",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Flood light",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Lampost",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
	{
	type: "Local control panel",
	static: [
	"Description",
	"Long Description (size)",
	"P&ID Class",
	"Status",
	"Tag",
	"Assembly",
	"Procurement Class",
	"Volume",
	"Area",
	],
	dynamic: [
	"Delivered To",
	"Installed By",
	"Manufacturer",
	"Model",
	"Process Group",
	"Purchased By",
	"Weight (kg)",
	"Material",
	"Installed By",
	"Construction Note 1",
	"Construction Note 2",
	"Reference Product",
	],
	ccms: [
	],
	},
]
